import React, { useEffect, useState, useContext } from 'react'
import ParentModal from '../../genericComponents/ParentModal';
import { deleteCookie, getCookie, parseJwt } from '../../helper/genericFunction';
import EditEmail from '../home/profileSection/userProfile/EditEmail';
import { dispatchHandler } from '../../helper/apiHelperFunctions';
import { useDispatch, useSelector } from 'react-redux';
import VendorMerge from './VendorMerge';
import FullPageLoader from '../../loaders/FullPageLoader';
import { isSetAutoLoginCookie } from '../../authComponents/login/helper/autoLoginFunctions';
import { setCookie } from '../../helper/genericFunction';
import { ReloadContext, UserDetailsContext } from '../../App';
import { useLocation, useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import DocumentViewer from '../../genericComponents/documentViewer/DocumentViewer';
import { getPayloadFromURLParams, setPayloadAsURLParams } from '../../helper/URLParamsHelper';
import { modifyDataForDocumentViewerUrlInsertion } from '../../helper/helperTableFunctions';
import { ASN_DOCUMENT_CONFIG, PO_DOCUMENT_CONFIG } from '../../helper/documentViewerConfigs';
import VendorDetailsModal from '../../genericComponents/vendorDetails/VendorDetailsModal';
import FirstLoginModal from './FirstLoginModal';
import { getPermissionKey } from '../../helper/permissions';
// Component : The default pop up component to show the modals at the login time
const DefaultPopUp = () => {
    const { handleDocumentStatusChange } = useContext(ReloadContext);
    const dispatch = useDispatch();
    const location = useLocation();
    const history = useHistory()

    const verifyOtpData = useSelector(state => state?.authStore?.verifyOtpData);
    const getPolicyVersionData = useSelector(state => state?.authStore?.getPolicyVersionData);

    const [openModal, setOpenModal] = useState(false);
    const [openModalData, setOpenModalData] = useState(null);

    // State : to store the refrehs pop up or not.
    const [refreshPopup, setRefreshPopup] = useState(false);

    const tokenData = parseJwt(sessionStorage.getItem("token") || "");

    const { clearUserContext } = useContext(UserDetailsContext);
    const [selectedModal, setSelectedModal] = useState(false)

    const [currentDocData, setCurrentDocData] = useState({})

    const [vendorData, setVendorData] = useState(null)

    useEffect(() => {
        dispatchHandler(dispatch, "getPolicyVersionRequest", {}, getPermissionKey("common", "commonfunctionality", "view"))
    }, [])

    useEffect(() => {
        if (getPolicyVersionData?.isSuccess) {
            let latestPolicyVersion = getPolicyVersionData?.data || {};
            if(latestPolicyVersion?.new_user == 1) {
                setOpenModal("firstLogin");
            } else if(latestPolicyVersion?.policy_version_update_required == 1) {
                setOpenModal("acceptPolicy");
            } else {
                setRefreshPopup(true);
            }
        }
    }, [getPolicyVersionData?.isSuccess])

    useEffect(() => {
        if (verifyOtpData?.isSuccess) {
            let token = verifyOtpData?.data?.resource?.token
            if (token) {
                sessionStorage?.removeItem("token");
                localStorage?.removeItem("token");
                sessionStorage?.setItem("token", token || "");
                localStorage?.setItem("token", token || "");
                deleteCookie();
                token && isSetAutoLoginCookie() && setCookie({ name: "jwt", value: token, hours: 6 })
            }
            if (tokenData?.mobileVerified == 1 && verifyOtpData?.data?.resource?.accMobNumDetailsList?.length > 0) {
                setOpenModal(false)
                requestAnimationFrame(() => {
                    setOpenModal("multipleAccountMerge");
                });
                setOpenModalData(verifyOtpData?.data?.resource?.accMobNumDetailsList || []);
            } else {
                setRefreshPopup(true);
            }
        }
    }, [verifyOtpData?.isSuccess])

    let { userDetails } = useContext(UserDetailsContext)

    useEffect(() => {
        // Condition : For first time loging in inside this.
        if (refreshPopup) {
            let response = userDetails?.["loginResponse"]
            if (response) {
                let loginResponse = JSON.parse(response);
                handleChangeModal(loginResponse);
            }
            setRefreshPopup(false);
        }
    }, [refreshPopup])

    useEffect(() => {
        // Condition : To check if the document viewer is open or not.
        checkDocumentViewerIsOpen();
    }, [location?.search, location?.pathname])

    const callOtpApi = (type) => {
        dispatchHandler(dispatch, "getOtpRequest", {
            token: sessionStorage?.getItem("token"),
            source: type
        })
    }

    const getUrlSearchParams = () => {
        const urlSearchParams = new URLSearchParams(location.search),
            params = Object.fromEntries(urlSearchParams.entries());

        Object.keys(params || {}).forEach(key => {
            params[key] = JSON.parse(decodeURIComponent?.(params?.[key] ?? ""));
        });

        return { params }
    }

    const checkDocumentViewerIsOpen = () => {
        const { params } = getUrlSearchParams();
        if (params?.documentViewerConfig) {
            if (openModal != "documentViewerModal") {
                updateDocumentViewerInfo();
                setSelectedModal("documentViewerModal");
            }
        }
        else if (params?.vendorDetailsConfig?.vendorCode) {
            setSelectedModal("vendorDetailsModal");
            setVendorData(params?.vendorDetailsConfig);
        }
        else {
            setSelectedModal(false);
            setVendorData(null);
        }
    }

    // Function : To get the document info from the location
    const updateDocumentViewerInfo = () => {
        let params = getPayloadFromURLParams({ l: location });

        let obj = {};
        if (params?.documentViewerConfig) {
            obj = modifyDataForDocumentViewerUrlInsertion("decode", params?.documentViewerConfig);
            if (["documentId", "documentNo", "documentType"]?.every(key => params?.documentViewerConfig?.[key])) {
                setCurrentDocData(obj);
            }
        } else {
            setCurrentDocData({});
        }
    }

    const handleChangeModal = (data) => {
        if (tokenData?.mobileVerified == 0) {
            setOpenModal("verifyMobile");
            callOtpApi("MOBILE");
        } else if (tokenData.emailVerified == 0) {
            setOpenModal("verifyEmail");
            callOtpApi("EMAIL");
        } else if (data?.pendingSignup > 0) {
            setOpenModal("vendorMerge");
        }
        else {
            setOpenModal(false);
            setOpenModalData(null);
        }
    }

    const getChildComponentV2 = () => {
        switch (selectedModal) {
            case "vendorDetailsModal": return VendorDetailsModal;
        }
    }

    const getParentChildPropsV2 = () => {
        let obj = {
            animationType: "bottom",
            parentModalOuterMostClassName: 'flex items-center justify-center',
            postitionProps: { position: 'relative' },
            dimensions: { width: "40vw", height: "auto", minHeight: '300px', maxWidth: '600px' },
            animationType: "bottom",
            closeModal: () => setOpenModal(false),
        }
        switch (selectedModal) {
            case "vendorDetailsModal": {
                return {
                    ...obj,
                    closeModal: () => {
                        updateUrlSearchParams({
                            data: {
                                vendorDetailsConfig: undefined
                            }
                        })

                    },
                    dimensions: { width: "80vw", height: "85vh", maxHeight: '800px', maxWidth: '1300px', borderRadius: 5 },
                    vendorDetailsConfig: vendorData,
                }
            }
        }
    }

    const getChildComponent = () => {
        switch (openModal) {
            case "verifyMobile":
            case "verifyEmail": return EditEmail;
            case "vendorMerge": return VendorMerge;
            case "fullPageLoader": return FullPageLoader;
            case "multipleAccountMerge": return VendorMerge;
            case "vendorDetailsModal": return VendorDetailsModal;
            case "firstLogin": case "acceptPolicy": return FirstLoginModal;
        }
    }

    const logoutFunction = async () => {
        let registrationJwt = getCookie('registrationJwt');
        setOpenModal("fullPageLoader")
        dispatchHandler(dispatch, "userSessionCreateRequest", { token: sessionStorage.getItem('token') || "", flowType: "LOGGEDOUT" });
        deleteCookie('jwt')
        if (registrationJwt) {
            deleteCookie('registrationJwt')
        }
        sessionStorage.clear();
        clearUserContext();
        setTimeout(() => {
            setOpenModal(false);
            handleDocumentStatusChange();
        }, 1000);
    }

    const getParentChildProps = () => {
        let obj = {
            isCloseBlocked: ["verifyEmail", "verifyMobile"]?.includes(openModal) ? true : false,
            animationType: "bottom",
            // postitionProps: { top: '50%', left: '50%', transform: 'translate(-50%, -50%)', position: "absolute", borderRadius: 4 },
            parentModalOuterMostClassName: 'flex items-center justify-center',
            postitionProps: { position: 'relative' },
            dimensions: { width: "40vw", height: "auto", minHeight: '300px', maxWidth: '600px' },
            animationType: "bottom",
            closeModal: () => setOpenModal(false),
        }
        switch (openModal) {
            case "verifyMobile":
            case "verifyEmail": {
                return {
                    ...obj,
                    dimensions: { width: "40vw", height: "auto", minHeight: '300px', maxWidth: '600px' },
                    "type": openModal == "verifyMobile" ? "mobile" : "email",
                    "flowName": "verifyEmailOrMobile",
                    logoutFunction: logoutFunction
                }
            }
            case "vendorMerge": {
                return {
                    ...obj,
                    dimensions: { width: "70vw", height: "80vh", maxHeight: '660px', maxWidth: '1000px', borderRadius: 5 },
                    // postitionProps: { top: '50%', left: '50%',transform: 'translate(-50%, -50%)', borderRadius: 4 },
                    parentModalOuterMostClassName: 'flex items-center justify-center',
                    postitionProps: { position: 'relative' },
                    skipModal: () => {
                        setOpenModal(false);
                    },
                    submitModal: () => {
                        logoutFunction();
                    }
                }
            }
            case "multipleAccountMerge": {
                return {
                    ...obj,
                    dimensions: { width: "70vw", height: "80vh", maxHeight: '660px', maxWidth: '1000px', borderRadius: 5 },
                    // postitionProps: { top: '50%', left: '50%',transform: 'translate(-50%, -50%)', borderRadius: 4 },
                    parentModalOuterMostClassName: 'flex items-center justify-center',
                    postitionProps: { position: 'relative' },
                    accMobNumDetailsList: openModalData,
                    multiAccountModal: true,
                    skipModal: () => {
                        setOpenModal(false);
                    },
                    submitModal: () => {
                        logoutFunction();
                    }
                }
            }
            case "vendorDetailsModal": {
                return {
                    ...obj,
                    closeModal: () => {
                        updateUrlSearchParams({
                            data: {
                                vendorDetailsConfig: undefined
                            }
                        })

                    },
                    dimensions: { width: "80vw", height: "85vh", maxHeight: '800px', maxWidth: '1300px', borderRadius: 5 },
                    vendorDetailsConfig: openModalData,
                }
            }
            case "firstLogin": case "acceptPolicy": {
                return {
                    ...obj,
                    setRefreshPopup: setRefreshPopup,
                    openModal: openModal,
                    policyVersionData: getPolicyVersionData?.data,
                    isCloseBlocked: true,
                    dimensions: { width: "85vw", height: "90vh", minHeight: '300px', maxHeight: '394px', maxWidth: '650px', borderRadius: 5 },
                }
            }
        }
    }

    if (openModal == "fullPageLoader") {
        return <FullPageLoader />;
    }

    const updateUrlSearchParams = (config = {}) => {
        let { data = {} } = config;

        // Remove the applied selected items from the URL search params 
        setPayloadAsURLParams({
            data: {
                ...getPayloadFromURLParams({
                    l: location,
                }),
                ...data,
            },
            l: location,
            h: history,
        })
    }

    const uType = tokenData?.uType?.toUpperCase() || "ENT";

    let tableHeadersMapOrders = uType == "ENT" ? {
        ALL_STATUS: {
            main: {
                name: "Main",
                key: "ENT_PENDING_ALL"
            },
            set: {
                name: "Set",
                key: "ENT_PENDING_SET"
            },
            item: {
                name: "Item",
                key: "ENT_PENDING_ICODE_ITEM"
            }
        },
    } : {
        APPROVED: {
            main: {
                name: "Main",
                key: "VENDOR_PENDING_ALL"
            },
            set: {
                name: "Set",
                key: "VENDOR_PENDING_ORDERS_SET"
            },
            item: {
                name: "Item",
                key: "VENDOR_PENDING_ORDERS_ICODE_ITEM"
            }
        }
    }

    let tableHeadersMapASN = uType == "ENT" ? {
        SHIPMENT_REQUESTED: {
            main: {
                name: "Main",
                key: "ENT_ASN_APPROVAL_ALL"
            },
            set: {
                name: "Set",
                key: "ENT_ASN_APPROVAL_SET"
            },
            item: {
                name: "Item",
                key: "ENT_ASN_APPROVAL_ITEM"
            }
        },
    } : {
        SHIPMENT_REQUESTED: {
            main: {
                name: "Main",
                key: "VENDOR_ASN_APPROVAL_ALL"
            },
            set: {
                name: "Set",
                key: "VENDOR_ASN_APPROVAL_SET"
            },
            item: {
                name: "Item",
                key: "VENDOR_ASN_APPROVAL_ITEM"
            }
        }
    }

    const handleChange = (type, data) => {
        switch (type) {
            case "openAsnDocViewer": {
                updateUrlSearchParams({
                    data: {
                        documentViewerConfig: undefined
                    }
                })
                setSelectedModal(false);
                setTimeout(() => {
                    let obj = modifyDataForDocumentViewerUrlInsertion("encode", {
                        documentId: data?.document_id ?? 10,
                        documentNo: data?.shipment_advice_code,
                        documentType: "ASN",
                        isBackAvaliable: true
                    });

                    // Update the url search params here.
                    setPayloadAsURLParams({
                        data: {
                            ...getPayloadFromURLParams({
                                l: location,
                            }),
                            documentViewerConfig: obj,
                        },
                        l: location,
                        h: history,
                    })
                }, 0);
                break;
            }

            default:
                break;
        }
    }

    const docViewConfig = {
        PO: PO_DOCUMENT_CONFIG({ uType, tab: uType == "ENT" ? "ALL_STATUS" : "APPROVED", tableHeadersMap: tableHeadersMapOrders, handleChange }),
        ASN: ASN_DOCUMENT_CONFIG({ uType, tab: "SHIPMENT_REQUESTED", tableHeadersMap: tableHeadersMapASN }),
    };

    return (
        <>
            {selectedModal == "documentViewerModal" &&
                <DocumentViewer
                    closeModal={() => {
                        updateUrlSearchParams({
                            data: {
                                documentViewerConfig: undefined
                            }
                        })
                    }}
                    documentViewerConfig={docViewConfig?.[currentDocData?.documentType] || {}}
                />}
            {(selectedModal && selectedModal !== "documentViewerModal") && <ParentModal
                childComponent={getChildComponentV2()}
                getParentChildProps={getParentChildPropsV2()}
                closeModal={() => setSelectedModal(false)}
            />}
            {openModal && <ParentModal
                childComponent={getChildComponent()}
                getParentChildProps={getParentChildProps()}
                closeModal={() => setOpenModal(false)}
            />}
        </>
    )
}

export default DefaultPopUp